import { createFileRoute, Link } from "@tanstack/react-router";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Eyebrow } from "@/components/brand/Eyebrow";

export const Route = createFileRoute("/store/checkout/cancel")({
  component: () => (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <section className="mx-auto max-w-2xl px-6 py-24 text-center">
        <Eyebrow align="center">Checkout cancelled</Eyebrow>
        <h1 className="mt-6 font-serif text-4xl text-navy-900">Your cart is still waiting</h1>
        <p className="mt-6 font-sans text-charcoal-500">No charge was made.</p>
        <div className="mt-10">
          <Link to="/store/cart" className="font-sans text-bronze-600 underline">Return to cart</Link>
        </div>
      </section>
      <Footer />
    </div>
  ),
});